import {
  type AirCfarExerciseQuoteResponse,
  AirCfarExerciseQuoteResponseEnum,
  type QuoteSuccess,
} from "@b2bportal/air-cfar-api";

import {
  AirCfarExerciseErrorQuoteFailure,
  type AirCfarExerciseErrorQuoteFailureProps,
} from "./AirCfarExerciseErrorQuoteFailure";

export interface AirCfarExerciseQuoteResponseLoaderProps
  extends Omit<AirCfarExerciseErrorQuoteFailureProps, "data"> {
  response: AirCfarExerciseQuoteResponse;
  children: (data: QuoteSuccess) => JSX.Element;
}

export const AirCfarExerciseQuoteResponseLoader = (
  props: AirCfarExerciseQuoteResponseLoaderProps
): JSX.Element | null => {
  const { children, response } = props;

  switch (response.AirCfarExerciseQuoteResponse) {
    case AirCfarExerciseQuoteResponseEnum.QuoteFailure: {
      return (
        <AirCfarExerciseErrorQuoteFailure
          data={response}
          termsAndConditionsLink={props.termsAndConditionsLink}
          goToRegularCancellationFlow={props.goToRegularCancellationFlow}
          goToPrevScreen={props.goToPrevScreen}
          goToContactSupport={props.goToContactSupport}
        />
      );
    }
    case AirCfarExerciseQuoteResponseEnum.QuoteSuccess:
      return children(response);
    default:
      return null;
  }
};
